// all lists created for MARTA2040 site. Only
export const tags = [
  {
    projectId: "allProjects",
    name: "All Projects",
    tagId: 752806
  },
  // {
  //     projectId: "CampbelltonBRT",
  //     tgId: 752010,
  //     name: "Campbellton BRT"
  // },
  {
    projectId: "CampbelltonCorr",
    tagId: 753626,
    name: "Campbellton Corridor Transit Project"
  }
];

// const campbelltonTags = [
//   {
//     "id": 753626,
//     "name": "Campbellton Corridor Transit Project"
//   },
//   {
//     "id": 786726,
//     "name": "CampbelltonCorr"
//   },
// ]
